// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module__categoryBlock--IaRzu{padding-bottom:24px}`, "",{"version":3,"sources":["webpack://./src/components/Pages/HelpCenterCategory/CategoryBlock/style.module.scss"],"names":[],"mappings":"AAAA,oCACE,mBAAA","sourcesContent":[".categoryBlock {\n  padding-bottom: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categoryBlock": `style-module__categoryBlock--IaRzu`
};
export default ___CSS_LOADER_EXPORT___;
